import { render, staticRenderFns } from "./CarryingIORecordsTable.vue.html?vue&type=template&id=5fb0947e&scoped=true&external"
import script from "./CarryingIORecordsTable.vue.js?vue&type=script&lang=js&external"
export * from "./CarryingIORecordsTable.vue.js?vue&type=script&lang=js&external"
import style0 from "./CarryingIORecordsTable.vue.scss?vue&type=style&index=0&id=5fb0947e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb0947e",
  null
  
)

export default component.exports